export default __webpack_public_path__ + "assets/img/377v2an.svg";